// Gatsby requirements
import React, { useState, useEffect } from "react"
import { Link, useStaticQuery, graphql } from 'gatsby'

// Components
import DarkModeToggle from '../DarkModeToggle/DarkModeToggle'
import RichText from "utils/RichTextRenderer"


// Styles
import * as CSS from './Header.module.scss'

const Header = (props) =>  {

    const data = useStaticQuery(graphql`
        query {
            storyblokEntry(full_slug: { eq: "site-configuration/header" }) {
                content
                id
                uuid
                internalId
            }
        }
    `)

    // Logic for opening the mobile header navigation
    const [isMenuOpen, setMenuOpen] = useState(false)

    // Add sublist icons
    useEffect(() => {
        var nums = document.getElementById("navigation");
        var listItem = nums.getElementsByTagName("li");
        for (let item of listItem) {
            if (item.childElementCount > 1) {
                item.classList.add("has-sublist");
                item.setAttribute('tabindex', '0')
            }
        }
    }, [])

    // Logic for header scroll behaviour
    const [scrollDir, setScrollDir] = useState("unset");

    useEffect(() => {
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;

        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY) < threshold) {
            ticking = false;
            return;
            }
            setScrollDir(scrollY > lastScrollY ? "scrolling-down" : "scrolling-up");
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
            window.requestAnimationFrame(updateScrollDir);
            ticking = true;
            }
        };

        window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
    }, [scrollDir]);

    useEffect(() => {
        // Remove dark mode on pages where it is disabled
        if (props.enableDarkMode === false) {
            document.documentElement.removeAttribute("color-mode", "dark")
        }

        // Hide header when scrolling to a hash
        if (window.location.hash) {
            setScrollDir("scrolling-down");
        }
    })

    const content = props?.previewData?.content || JSON.parse(data?.storyblokEntry?.content);

    return(
        <header 
            className={`
                ${CSS.header} 
                ${!props.isPageHomepage ? scrollDir : ''}
                ${isMenuOpen ? CSS.active: ''}
            `}
        >
            
            <div className={CSS.wrapper}>

                <a className={CSS.skip} href="#content">Skip to content</a>

                <button
                    aria-haspopup="true"
                    aria-label="Open main menu"
                    aria-expanded={isMenuOpen === true ? "true" : "false"}
                    onClick={() =>
                        isMenuOpen === true
                        ? setMenuOpen(false)
                        : setMenuOpen(true)
                    }
                    >
                        <svg viewBox="0 0 100 80" width="30" height="30">
                            <rect width="100" height="11" rx="8"></rect>
                            <rect y="30" width="100" height="11" rx="8"></rect>
                            <rect y="60" width="100" height="11" rx="8"></rect>
                        </svg>
                </button>
                
                <Link to="/" aria-label="Link to homepage">
                    <img loading="eager" className={CSS.logo} src="/frida_logo.svg" height="54" width="93" alt="Frida logo"/>
                </Link>

                <div className={CSS.navAndDarkmodeToggle}>

                    <nav id="navigation" className={CSS.navigation}>
                        <RichText content={content.navigation} />
                    </nav>

                    {props.enableDarkMode === true &&
                        <DarkModeToggle/>
                    }

                </div>

                
            </div>

        </header>
    )
}

export default Header